import { useUserContext } from 'common/contexts/UserContext';
import { Routes } from 'constants/pages';
import { SignupStatus } from 'constants/user';
import { SignUpTemplate } from 'layouts/SignUpTemplate';
import { Header } from 'layouts/SignUpTemplate/components/Header';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

export const AwaitingAdmin: React.FC = () => {
  const { user, fetchUser } = useUserContext();
  const navigate = useNavigate();
  useQuery(['fetchUser'], fetchUser, {
    refetchOnWindowFocus: true,
    refetchInterval: 1000 * 30,
  });

  // If the user is sitting on this page when their admin confirms,
  // we need to make sure they're redirected once they become complete again.
  React.useEffect(() => {
    if (user?.signup_status === SignupStatus.Complete) {
      return navigate(Routes.Landing, { replace: true });
    }
    // https://stackoverflow.com/questions/64886159/consistent-return-for-useeffect
    return undefined;
  }, [user?.signup_status, navigate]);

  const companyName = user?.membership;
  return (
    <SignUpTemplate>
      <div className="flex flex-col items-center">
        <div className="w-full max-w-[496px] space-y-16">
          <div className="text-center space-y-3">
            <Header
              header="Your request has been sent!"
              subHeader={`Your request to join ${companyName} has been sent to your team members. You will be notified by email
              as soon as you are granted access to your company account.`}
            />
            <div className="text-gray-900 pt-16">
              Any questions?{` `}
              <a href="mailto:contact@bluecargo.io" className="underline">
                Contact Support
              </a>
              {` `}
              or call us at +1-650-480-1760
            </div>
          </div>
        </div>
      </div>
    </SignUpTemplate>
  );
};
